import type { AccessDecision } from '../../../core/components/PermissionGuard/PermissionGuard';

export const FOOD_SEGMENT = 'FOOD';

export type WorkforceAccessDecision = AccessDecision;

type ResolveWorkforceAccessParams = {
  flagEnabled: boolean;
  isChecking: boolean;
  hasPermission: boolean;
  // Optional because the site data feeding this (GET /v1.0/profile/branches)
  // can omit the field (1011251) — the caller passes through whatever it has.
  siteSegment: string | undefined;
};

/**
 * Decides whether the /workforce-sizing route may render.
 *
 * Fail-closed: anything other than an enabled flag, a granted permission and a
 * FOOD cost center is denied. The order preserves the loading state so the
 * redirect only fires once the permission check has resolved. The FOOD-segment
 * gate is what prevents FM cost centers from reaching the feature via a direct
 * URL (work item 800526).
 */
export const resolveWorkforceAccess = ({
  flagEnabled,
  isChecking,
  hasPermission,
  siteSegment,
}: ResolveWorkforceAccessParams): WorkforceAccessDecision => {
  if (!flagEnabled) return 'deny';
  if (isChecking) return 'loading';
  if (!hasPermission) return 'deny';
  if ((siteSegment ?? '').toUpperCase() !== FOOD_SEGMENT) return 'deny';
  return 'allow';
};
